var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVagas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4615 2H8.53846C6.41346 2 5.02404 3.11364 4.61538 5.18182L2 17.2727V26.1818C2.00302 27.1936 2.41731 28.163 3.15238 28.8784C3.88744 29.5938 4.88354 29.9971 5.92308 30H32.0769C33.1165 29.9971 34.1126 29.5938 34.8476 28.8784C35.5827 28.163 35.997 27.1936 36 26.1818V17.2727L33.3846 5.18182C32.976 3.03409 31.5048 2 29.4615 2Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.2726H13.7692C13.7692 18.6228 14.3203 19.9177 15.3013 20.8725C16.2822 21.8272 17.6127 22.3635 19 22.3635C20.3873 22.3635 21.7178 21.8272 22.6987 20.8725C23.6797 19.9177 24.2308 18.6228 24.2308 17.2726H36M9.84615 7.09082H28.1538M8.53846 12.1817H29.4615",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVagas);
export default __webpack_public_path__ + "static/media/icon-vagas.1d74c0c6b97548e38f6c0a39a44095c0.svg";
export { ForwardRef as ReactComponent };